'use client'

import { Button, Container } from '@/components'
import Image from 'next/image'

import styles from './styles.module.scss'
import logoUrl from '/public/icons/logo.svg'
import logoPinkUrl from '/public/icons/logo-pink.svg'

export default function Header({ hasLogin, isPink = false }) {
  return (
    <nav className={styles.navbar}>
      <Container>
        <div className={styles.content}>
          <figure>
            <Image
              quality={100}
              src={isPink ? logoPinkUrl : logoUrl}
              alt="Logo Foguete"
              width={221}
              height={40}
              className={styles.navbar__logo}
            />
          </figure>
          {hasLogin && (
            <Button
              href="https://app.academiafoguete.com.br/login"
              outline
              className={styles.navbar__btn}
              target="_blank"
            >
              Login
            </Button>
          )}
        </div>
      </Container>
    </nav>
  )
}
